import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.string.trim";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getActivityInviteGroupList, deleteActivityInviteGroupList, updateActivityInviteGroupList, createActivityInviteGroupList } from '@/api/bairun/oilActivity'; //  此处请自行替换地址

import { getActivityList, getActivityDetail, createActivity, updateActivity, deleteActivity, auditActivity, updateActivityStatus } from '@/api/bairun/oilActivity'; //  此处请自行替换地址

import { getTicketRuleDetail } from '@/api/bairun/ticket'; //  此处请自行替换地址

import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';

var _this;

export default {
  name: 'InviteGroup',
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getActivityInviteGroupList,
      dialogFormVisible: false,
      viewVisible: false,
      dialogTitle: '',
      type: '',
      multipleSelection: [],
      formData: {
        qrcodeType: 1,
        groupName: '',
        invitedTicket: '',
        invitedTicketList: [this.initTicketSingle()],
        remark: ''
      },
      rules: {
        groupName: [{
          required: true,
          message: '请输入群名称',
          trigger: 'blur'
        }],
        qrcodeType: [{
          required: true,
          message: '请选择二维码类型',
          trigger: 'blur'
        }]
      }
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this2.getTableData();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    // 条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      this.getTableData();
    },
    onReset: function onReset() {
      this.searchInfo = {};
      this.onSubmit();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    initTicketSingle: function initTicketSingle() {
      return {
        ticketRuleNo: '',
        num: 1
      };
    },
    // 添加被邀请者券
    onAddInvitedTicket: function onAddInvitedTicket(index) {
      var that = this;
      that.formData.invitedTicketList.splice(index + 1, 0, that.initTicketSingle());
      this.$forceUpdate();
    },
    // 删除被邀请者券
    onDeleteInvitedTicket: function onDeleteInvitedTicket(index) {
      debugger;
      var that = this;

      if (that.formData.invitedTicketList.length == 1) {
        return;
      }

      that.formData.invitedTicketList.splice(index, 1);
      this.$forceUpdate();
    },
    // 获取券详情
    getTicketDetail: function getTicketDetail(item) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(item.ticketRuleNo.trim() != '')) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 3;
                return getTicketRuleDetail({
                  'ticketRuleNo': parseFloat(item.ticketRuleNo)
                });

              case 3:
                res = _context2.sent;

                if (res.code == 0) {
                  item.ticketRuleNo = res.data.ticketRuleNo + '';
                } else {
                  item.ticketRuleNo = '';
                }

              case 5:
                _this3.$forceUpdate();

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    onAdd: function onAdd() {
      this.type = 'create';
      this.dialogFormVisible = true;
      this.dialogTitle = '新增操作';
    },
    onUpdate: function onUpdate(row) {
      this.type = 'update';
      this.dialogFormVisible = true;
      this.dialogTitle = '变更操作';
      this.handleViewOrUpdate(row);
    },
    onView: function onView(row) {
      this.type = 'view';
      this.viewVisible = true;
      this.dialogTitle = '查看操作';
      this.handleViewOrUpdate(row);
    },
    handleViewOrUpdate: function handleViewOrUpdate(row) {
      debugger;
      var that = this;
      that.formData = JSON.parse(JSON.stringify(row));
      that.formData.invitedTicketList = JSON.parse(row.invitedTicket);

      if (!that.formData.invitedTicketList || that.formData.invitedTicketList.length === 0) {
        that.formData.invitedTicketList = [that.initTicketSingle()];
      }
    },
    onDelete: function onDelete(row) {
      var _this4 = this;

      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return deleteActivityInviteGroupList({
                  ID: row.ID
                });

              case 2:
                res = _context3.sent;

                if (res.code === 0) {
                  _this4.$message({
                    type: 'success',
                    message: '删除成功'
                  });

                  if (_this4.tableData.length === 1) {
                    _this4.page--;
                  }

                  _this4.getTableData();
                } // eslint-disable-next-line handle-callback-err


              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))).catch(function (err) {});
    },
    enterDialog: function enterDialog() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var that;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                that = _this5;
                _context4.t0 = that.type;
                _context4.next = _context4.t0 === 'create' ? 4 : _context4.t0 === 'update' ? 6 : 8;
                break;

              case 4:
                that.$refs['formData'].validate(function (valid) {
                  if (valid) {
                    that.formData.invitedTicket = JSON.stringify(that.formData.invitedTicketList.filter(function (item) {
                      return item.ticketRuleNo !== '' && item.num > 0;
                    }));
                    createActivityInviteGroupList(that.formData).then(function (res) {
                      that.enterDialogRepose(res);
                    });
                  } else {
                    return false;
                  }
                });
                return _context4.abrupt("break", 9);

              case 6:
                that.$refs['formData'].validate(function (valid) {
                  if (valid) {
                    that.formData.invitedTicket = JSON.stringify(that.formData.invitedTicketList.filter(function (item) {
                      return item.ticketRuleNo !== '' && item.num > 0;
                    }));
                    updateActivityInviteGroupList(that.formData).then(function (res) {
                      that.enterDialogRepose(res);
                    });
                  } else {
                    return false;
                  }
                });
                return _context4.abrupt("break", 9);

              case 8:
                return _context4.abrupt("break", 9);

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    enterDialogRepose: function enterDialogRepose(res) {
      if (res.code === 0) {
        this.$message({
          type: 'success',
          message: '操作成功'
        });
        this.closeDialog();
        this.getTableData();
      }
    },
    closeDialog: function closeDialog() {
      this.dialogFormVisible = false;
      this.viewVisible = false;
      this.dialogTitle = '';
      this.type = '';
      this.formData = {
        qrcodeType: 1,
        groupName: '',
        invitedTicket: '',
        invitedTicketList: [this.initTicketSingle()],
        remark: ''
      };
    }
  }
};